var _style, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 149.5 205.3",
    style: {
      enableBackground: "new 0 0 149.5 205.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#F3F3EA;}\n")), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "DeleteIcon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M16.3,50.1h116.8l0,0v113.1c0,13-10.5,23.5-23.5,23.5h0H39.8c-13,0-23.5-10.5-23.5-23.5l0,0 C16.3,163.1,16.3,50.1,16.3,50.1z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M15.9,21.2h117.8c4.8,0,8.6,3.9,8.6,8.6v12.6l0,0H7.2l0,0V29.9C7.2,25.1,11.1,21.3,15.9,21.2 C15.9,21.2,15.9,21.2,15.9,21.2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M52,13.7h45.5c5.2,0,9.5,4.2,9.5,9.5c0,0,0,0,0,0l0,0l0,0H42.5l0,0l0,0C42.5,17.9,46.7,13.7,52,13.7 C52,13.7,52,13.7,52,13.7z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/DeleteIcon.a0366c2f56699fbceab8e342571f7456.svg";
export { ForwardRef as ReactComponent };